<template>
  <ValidationObserver v-slot="{ handleSubmit }">
    <b-modal
      v-model="modal.show"
      :title="modalTitle"
      ok-title="Submit"
      :ok-disabled="okButtonDisabled"
      scrollable
      size="lg"
      @ok.prevent="handleSubmit(onSubmit)"
      @hidden="onHideModal"
      @show="onShowModal"
    >
      <content-spinner :show="loading" />
      <b-form
        v-if="!loading"
        @submit.prevent="handleSubmit(onSubmit)"
        @keydown.enter.prevent="handleSubmit(onSubmit)"
      >
        <input-widget
          v-for="field in addEditBatchModalFields"
          :key="field.name"
          :model="form"
          :field="field"
          :autofocus="field.autofocus"
        />
      </b-form>
    </b-modal>
  </ValidationObserver>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
import {v4 as uuidv4} from 'uuid';
import InputWidget from '../../../../core/components/complex-table/components/InputWidget';
import ContentSpinner from '../../../../core/components/ContentSpinner';
import {fileManipulationMixin} from '@/modules/FileManipulationController/file-manipulation.mixin';

const {
  mapState,
  mapActions,
} = createNamespacedHelpers('fileManipulationController');

export default {
  name: 'AddEditBatchModal',
  mixins:[fileManipulationMixin],
  components: {
    ContentSpinner,
    InputWidget,
  },
  data() {
    return {
      form: {
        batchName: null,
        batchGuid: null,
        waitingDir: null,
        processedDir: null,
        exceptionDir: null,
        controlFileNamePattern: null,
        controlFileDelimiter: null,
        emailRecipientsOnSuccess: null,
        emailRecipientsOnFailure: null,
        emailRecipientsOnCompletion: null,
        emailNotificationFrom: null,
        batchFiles: [],
      },
      loading: false,
    };
  },
  computed: {
    ...mapState({
      modal: state => state.addEditModal,
    }),
    modalTitle() {
      return this.isEditMode ? 'Edit Batch' : 'Add New Batch';
    },
    isEditMode() {
      return this.modal.data.item;
    },
    okButtonDisabled() {
      return this.loading;
    },
  },
  methods: {
    ...mapActions(['upsertBatch', 'hideAddEditModal']),
    async onSubmit() {
      this.loading = true;

      const params = {...this.form};
      // delete params.batchFiles; // should remove in future

      let action = 'update';
      if (!params.batchGuid) {
        action = 'create';
        params.batchGuid = uuidv4();
      }

      const {success, body} = await this.upsertBatch({params, action});
      if (success) {
        this.$toasted.success(`Batch ${action}d successfully`, {
          duration: TOASTER_DURATION || 3000,
        });

        this.hideAddEditModal();
      } else {
        this.$toasted.error(body.ErrorMessage, {
          duration: TOASTER_DURATION || 3000,
        });
      }

      this.loading = false;
    },
    onShowModal() {
      if (this.isEditMode) {
        this.form = {...this.modal.data.item};
      }
    },
    onHideModal() {
      this.resetForm();
    },
    resetForm() {
      this.form = {
        batchName: null,
        batchGuid: null,
        waitingDir: null,
        processedDir: null,
        exceptionDir: null,
        controlFileNamePattern: null,
        controlFileDelimiter: null,
        emailRecipientsOnSuccess: null,
        emailRecipientsOnFailure: null,
        emailRecipientsOnCompletion: null,
        emailNotificationFrom: null,
        batchFiles: [],
      };
    },
  },
};
</script>